window.QuotableIntegration = {}